"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QtyBreaksDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ExpandLess = _interopRequireDefault(require("@material-ui/icons/ExpandLess"));
var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var QtyBreaksDropdown = exports.QtyBreaksDropdown = function QtyBreaksDropdown(props) {
  var focusDiv = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (focusDiv.current && window.innerWidth > 768 && props.skuTable && !props.areAllRowsExpanded) {
      focusDiv.current.focus();
    }
  }, [focusDiv, props.areAllRowsExpanded, props.skuTable]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: 0,
    ref: focusDiv,
    className: props.small ? "qty-breaks-dropdown small" : "qty-breaks-dropdown",
    onKeyPress: function onKeyPress(e) {
      return props.onClick(e);
    },
    onClick: function onClick(e) {
      return props.onClick(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", null, props.title), props.expand ? /*#__PURE__*/_react["default"].createElement(_ExpandLess["default"], {
    className: "icon-red"
  }) : /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], {
    className: "icon-red"
  })));
};
//# sourceMappingURL=qtyBreaksDropdown.js.map